import { createSelector } from 'reselect';

export const getOrderPhone = state => state.getIn(['ordersSearch', 'orderPhone']);
export const getOrderId = state => state.getIn(['ordersSearch', 'orderId']);
export const getOrder = state => state.getIn(['ordersSearch', 'order']);